module.exports = "pegasus/assets/theme3/medium/3.jpg";